const VerifiedResellerIcon = ({ ...props }) => {
  return (
    <svg
      width="97"
      height="22"
      viewBox="0 0 97 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="22" height="22" rx="11" fill="#2882ED" />
      <path
        d="M6.91663 11.583L9.24996 13.9163L15.0833 8.08301"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.132 7.06H30.908L33.188 13.936L35.456 7.06H37.232L34.124 16H32.252L29.132 7.06ZM40.2312 7.06H46.1712V8.5H41.8632V10.792H45.9312V12.232H41.8632V14.56H46.1712V16H40.2312V7.06ZM49.3679 7.06H52.6919C53.2999 7.06 53.8399 7.172 54.3119 7.396C54.7839 7.612 55.1479 7.932 55.4039 8.356C55.6679 8.78 55.7999 9.288 55.7999 9.88C55.7999 10.488 55.6559 11.012 55.3679 11.452C55.0799 11.884 54.6839 12.204 54.1799 12.412L56.2319 16H54.3839L52.5359 12.7H50.9999V16H49.3679V7.06ZM52.7159 11.26C53.1559 11.26 53.5079 11.136 53.7719 10.888C54.0359 10.632 54.1679 10.296 54.1679 9.88C54.1679 9.464 54.0359 9.132 53.7719 8.884C53.5079 8.628 53.1559 8.5 52.7159 8.5H50.9999V11.26H52.7159ZM59.3015 7.06H60.9335V16H59.3015V7.06ZM64.6531 7.06H70.6171V8.5H66.2851V10.972H70.0771V12.412H66.2851V16H64.6531V7.06ZM73.6843 7.06H75.3163V16H73.6843V7.06ZM79.0359 7.06H84.9759V8.5H80.6679V10.792H84.7359V12.232H80.6679V14.56H84.9759V16H79.0359V7.06ZM88.1726 7.06H91.0886C92.0246 7.06 92.8446 7.248 93.5486 7.624C94.2526 8 94.7966 8.528 95.1806 9.208C95.5646 9.88 95.7566 10.652 95.7566 11.524C95.7566 12.388 95.5646 13.16 95.1806 13.84C94.7966 14.52 94.2486 15.052 93.5366 15.436C92.8326 15.812 92.0166 16 91.0886 16H88.1726V7.06ZM91.1246 14.56C91.7246 14.56 92.2486 14.436 92.6966 14.188C93.1526 13.94 93.5006 13.588 93.7406 13.132C93.9886 12.668 94.1126 12.132 94.1126 11.524C94.1126 10.916 93.9886 10.384 93.7406 9.928C93.5006 9.472 93.1526 9.12 92.6966 8.872C92.2486 8.624 91.7246 8.5 91.1246 8.5H89.8046V14.56H91.1246Z"
        fill="#2882ED"
      />
    </svg>
  );
};

export default VerifiedResellerIcon;
